/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import {
  ICliente,
  ICrearControl,
  IFilter,
  IQueryParam,
  ISirena,
  ISocketMessage,
} from 'modelos/src';
import { firstValueFrom, Observable, Subject, Subscription } from 'rxjs';
import { HelperService } from '../../../auxiliares/servicios/helper.service';
import { ListadosService } from '../../../auxiliares/servicios/listados.service';
import { WebSocketService } from '../../../auxiliares/servicios/websocket';
import { ControlesService } from '../controles.service';

@Component({
  selector: 'app-crear-controles',
  templateUrl: './crear-controles.component.html',
  styleUrls: ['./crear-controles.component.scss'],
  standalone: false,
})
export class CrearControlesComponent implements OnInit, OnDestroy {
  private fb = inject(UntypedFormBuilder);
  private dialogRef =
    inject<MatDialogRef<CrearControlesComponent>>(MatDialogRef);
  private service = inject(ControlesService);
  private helper = inject(HelperService);
  private listadosService = inject(ListadosService);
  private webSocketService = inject(WebSocketService);

  formulario?: UntypedFormGroup;
  loading = false;
  title?: string;
  hide = true;

  clientes: ICliente[] = [];

  sirenas: ISirena[] = [];
  sirenas$?: Observable<ISirena[]>;
  inputSirenas$ = new Subject<string>();

  private wsSubscription?: Subscription;

  private crearFormulario(): void {
    this.title = 'Crear Control';
    this.formulario = this.fb.group({
      chipIdSirena: [],
      etiqueta: [],
      chipId: [null, [Validators.required, Validators.minLength(4)]],
      idCliente: [],
      incrementar: [false],
    });
  }

  public close(): void {
    this.dialogRef.close();
  }

  private getData(): ICrearControl {
    const data: ICrearControl = {
      chipId: this.formulario?.get('chipId')?.value,
      etiqueta: this.formulario?.get('etiqueta')?.value?.trim() || undefined,
    };
    return data;
  }

  public async enviar(): Promise<void> {
    this.loading = true;
    try {
      const data = this.getData();
      await firstValueFrom(this.service.crear(data));
      this.helper.notifSuccess('Creado correctamente');
      //
      this.formulario?.patchValue({ chipId: null });
      // Incremento de etiqueta para cargar controles en serie
      const incrementar = this.formulario?.get('incrementar')?.value;
      const siguiente = HelperService.siguienteEtiqueta(data.etiqueta);
      if (incrementar && siguiente) {
        this.formulario?.patchValue({ etiqueta: siguiente });
      } else {
        if (incrementar && data.etiqueta) {
          this.helper.notifWarn(
            `La etiqueta "${data.etiqueta}" no termina en número, no se pudo incrementar`,
          );
        }
        this.formulario?.patchValue({ etiqueta: null });
      }
    } catch (error) {
      console.error(error);
      this.helper.notifError(error);
    }
    this.loading = false;
  }

  public searchSirenas = (term: string, item: ISirena) => {
    if (item.chipId?.toLowerCase().includes(term.toLowerCase())) return true;
    if (item.direccionGps?.toLowerCase().includes(term.toLowerCase()))
      return true;
    if (item.direccionManual?.toLowerCase().includes(term.toLowerCase()))
      return true;
    return false;
  };

  // Listados
  private async listarSirenas() {
    const filter: IFilter<ISirena> = {
      'configs.puedeEnviarControlesDesconocidos': true,
    } as any;
    const query: IQueryParam = {
      filter: JSON.stringify(filter),
      select: 'chipId direccionGps direccionManual',
    };

    this.sirenas = await firstValueFrom(
      this.listadosService.listarSirenas$(query),
    );

    console.log('Sirenas para controles desconocidos:', this.sirenas);
  }

  // ################################################################################
  // ################################# SUSCRIBE #####################################
  // ################################################################################

  private suscribeWsUpdates() {
    this.wsSubscription = this.webSocketService.getMessage().subscribe({
      next: this.handleUpdateResponse.bind(this),
    });
  }

  private handleUpdateResponse(message: ISocketMessage) {
    if (message.paths?.includes('controlnoconocido')) {
      const body: {
        chipIdControl: string;
        chipIdSirena: string;
        etiqueta: string;
      } = message.body as {
        chipIdControl: string;
        chipIdSirena: string;
        etiqueta: string;
      };
      const sirenaElegida = this.formulario?.get('chipIdSirena')?.value;
      const etiqueta = body.etiqueta;
      const chipId = body.chipIdControl;
      if (sirenaElegida === body.chipIdSirena) {
        if (etiqueta) {
          this.helper.notifWarn(
            `Control chipId ${chipId} cargado con la etiqueta ${etiqueta}`,
          );
        } else {
          this.formulario?.patchValue({ chipId });
        }
      }
    }
  }

  //

  async ngOnInit(): Promise<void> {
    this.loading = true;
    this.crearFormulario();
    this.suscribeWsUpdates();
    await this.listarSirenas();
    this.loading = false;
  }

  ngOnDestroy(): void {
    this.wsSubscription?.unsubscribe();
  }
}
